CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
CustomFieldOption = require 'models/custom-field-option'

module.exports = class CustomFieldOptionList extends CollectionWithHelpers
  model: CustomFieldOption
  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (option) -> option.get('pos')



// WEBPACK FOOTER //
// ./app/scripts/models/collections/custom-field-option-list.coffee